import { useEffect, useState } from "react";

export function useSaveData(): boolean {
  const [saveData, setSaveData] = useState(false);
  useEffect(() => {
    const connection = (navigator as Navigator & { connection?: { saveData?: boolean; effectiveType?: string } }).connection;
    setSaveData(Boolean(connection?.saveData || ["slow-2g", "2g"].includes(connection?.effectiveType ?? "")));
  }, []);
  return saveData;
}
